// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stHype_holder_stats_token_name {
    font-size: 18px;
    font-weight: 600;
    /* color: var(--primary-color); */
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--border-color);
    font-family: var(--app-font-family);
}

.stHype_holder_stats_card {
    border: 1px solid black;
    padding: 24px;
    margin: 0;
    color: var(--text-color);
}

.stHype_holder_stats_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.stHype_holder_stats_title {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color);
}

.stHype_holder_stats_count {
    color: var(--primary-color);
    font-size: 28px;
    font-family: var(--app-font-family);
}

.stHype_holder_stats_periods {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

.stHype_holder_stats_period {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.stHype_holder_stats_period_label {
    font-size: 14px;
    color: var(--text-color);
}

.stHype_holder_stats_period_value {
    font-family: var(--app-font-family);
}

.stHype_holder_stats_period_value.positive {
    color: var(--positive-color);
}

.stHype_holder_stats_period_value.negative {
    color: var(--negative-color);
}

.stHype_holder_stats_period_value.zero {
    color: var(--primary-color);
}

.stHype_holder_stats_period_select_container {
    position: relative;
    margin-bottom: 20px;
}

.stHype_holder_stats_period_selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    color: var(--primary-color);
    cursor: pointer;
}

.stHype_holder_stats_select_arrow {
    width: 16px;
    height: 16px;
    transition: transform 0.2s;
}

.stHype_holder_stats_period_select_container[aria-expanded="true"] .stHype_holder_stats_select_arrow {
    transform: rotate(180deg);
}

.stHype_holder_stats_period_options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
    z-index: 10;
}

.stHype_holder_stats_period_option {
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.stHype_holder_stats_period_option:hover {
    background-color: var(--hover-background);
}

.stHype_holder_stats_period_option.selected {
    background-color: var(--primary-color);
    color: #ffffff;
}

.stHype_holder_stats_chart_container {
    height: 120px;
    margin-top: 16px;
    position: relative;
}

.stHype_holder_stats_chart_tooltip {
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 8px 12px;
    font-family: var(--app-font-family);
    font-size: 12px;
    line-height: 1.4;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stHype_holder_stats_loading,
.stHype_holder_stats_error {
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    padding: 24px;
    margin: 0;
    text-align: center;
}

.stHype_holder_stats_loading .stHype_holder_stats_token_name,
.stHype_holder_stats_error .stHype_holder_stats_token_name {
    text-align: left;
    margin-bottom: 24px;
}

.stHype_holder_stats_loading_text,
.stHype_holder_stats_error_text {
    font-size: 18px;
    color: var(--primary-color);
    margin-bottom: 8px;
}

.stHype_holder_stats_loading_subtext,
.stHype_holder_stats_error_subtext {
    font-size: 14px;
    color: var(--text-color);
    opacity: 0.7;
    margin-bottom: 16px;
}

.stHype_holder_stats_progress_bar {
    width: 100%;
    height: 4px;
    background-color: rgba(0, 36, 117, 0.2);
    border-radius: 2px;
    overflow: hidden;
}

.stHype_holder_stats_progress_fill {
    height: 100%;
    background-color: var(--primary-color);
    transition: width 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/styles/stHype/staking/holderStatsCards.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;IAC5C,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,2BAA2B;AAC/B","sourcesContent":[".stHype_holder_stats_token_name {\n    font-size: 18px;\n    font-weight: 600;\n    /* color: var(--primary-color); */\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--border-color);\n    font-family: var(--app-font-family);\n}\n\n.stHype_holder_stats_card {\n    border: 1px solid black;\n    padding: 24px;\n    margin: 0;\n    color: var(--text-color);\n}\n\n.stHype_holder_stats_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.stHype_holder_stats_title {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--text-color);\n}\n\n.stHype_holder_stats_count {\n    color: var(--primary-color);\n    font-size: 28px;\n    font-family: var(--app-font-family);\n}\n\n.stHype_holder_stats_periods {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.stHype_holder_stats_period {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.stHype_holder_stats_period_label {\n    font-size: 14px;\n    color: var(--text-color);\n}\n\n.stHype_holder_stats_period_value {\n    font-family: var(--app-font-family);\n}\n\n.stHype_holder_stats_period_value.positive {\n    color: var(--positive-color);\n}\n\n.stHype_holder_stats_period_value.negative {\n    color: var(--negative-color);\n}\n\n.stHype_holder_stats_period_value.zero {\n    color: var(--primary-color);\n}\n\n.stHype_holder_stats_period_select_container {\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.stHype_holder_stats_period_selected {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 16px;\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    color: var(--primary-color);\n    cursor: pointer;\n}\n\n.stHype_holder_stats_select_arrow {\n    width: 16px;\n    height: 16px;\n    transition: transform 0.2s;\n}\n\n.stHype_holder_stats_period_select_container[aria-expanded=\"true\"] .stHype_holder_stats_select_arrow {\n    transform: rotate(180deg);\n}\n\n.stHype_holder_stats_period_options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    margin-top: 4px;\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    overflow: hidden;\n    z-index: 10;\n}\n\n.stHype_holder_stats_period_option {\n    padding: 8px 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.stHype_holder_stats_period_option:hover {\n    background-color: var(--hover-background);\n}\n\n.stHype_holder_stats_period_option.selected {\n    background-color: var(--primary-color);\n    color: #ffffff;\n}\n\n.stHype_holder_stats_chart_container {\n    height: 120px;\n    margin-top: 16px;\n    position: relative;\n}\n\n.stHype_holder_stats_chart_tooltip {\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-family: var(--app-font-family);\n    font-size: 12px;\n    line-height: 1.4;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.stHype_holder_stats_loading,\n.stHype_holder_stats_error {\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    padding: 24px;\n    margin: 0;\n    text-align: center;\n}\n\n.stHype_holder_stats_loading .stHype_holder_stats_token_name,\n.stHype_holder_stats_error .stHype_holder_stats_token_name {\n    text-align: left;\n    margin-bottom: 24px;\n}\n\n.stHype_holder_stats_loading_text,\n.stHype_holder_stats_error_text {\n    font-size: 18px;\n    color: var(--primary-color);\n    margin-bottom: 8px;\n}\n\n.stHype_holder_stats_loading_subtext,\n.stHype_holder_stats_error_subtext {\n    font-size: 14px;\n    color: var(--text-color);\n    opacity: 0.7;\n    margin-bottom: 16px;\n}\n\n.stHype_holder_stats_progress_bar {\n    width: 100%;\n    height: 4px;\n    background-color: rgba(0, 36, 117, 0.2);\n    border-radius: 2px;\n    overflow: hidden;\n}\n\n.stHype_holder_stats_progress_fill {\n    height: 100%;\n    background-color: var(--primary-color);\n    transition: width 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
